import React, { FC } from 'react';
import Modal from './common/Modal/Modal';
import { selectModalSlice } from '../redux/slices/modalSlice';
import { useAppSelector, useFromChainWalletAddress } from '../hooks';
import { selectBridgeSlice } from '../redux/slices/bridgeSlice';

const ModalWalletDetail: FC = () => {
  const { selectedFromChain } = useAppSelector(selectBridgeSlice);
  const fromChainWalletAddress = useFromChainWalletAddress();
  const { modalShowing } = useAppSelector(selectModalSlice);

  const copyStatusDisplayRef = React.useRef<HTMLButtonElement | null>(null);

  const handleCopyClipBoard = async (text: string) => {
    try {
      await navigator.clipboard.writeText(text);
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <Modal
      isShow={modalShowing === `WalletDetail`}
      size="sm"
      title="My Wallet"
      footerComponent={
        <button
          ref={copyStatusDisplayRef}
          className="btn btn-block btn-lg"
          onClick={() => handleCopyClipBoard(fromChainWalletAddress || ``)}
        >
          <i data-icon="copy" /> Copy Wallet address
        </button>
      }
    >
      <a
        href={
          selectedFromChain
            ? selectedFromChain.explorerUrl +
              selectedFromChain.explorerAddressPrefix +
              fromChainWalletAddress
            : `#`
        }
        className="wallet-name"
        target="_blank"
        rel="noreferrer"
      >
        <i data-icon="window" />
        {fromChainWalletAddress}
      </a>
    </Modal>
  );
};

export default ModalWalletDetail;
